export type { TrailsTableProps } from "./trails-table";
export { TrailsTable } from "./trails-table";
